import React, { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Box, Button, Container, Snackbar, TextField, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import MediaUploadField from "../MediaUploadField";

const EditorDocumentos = () => {
  const apiUrl = process.env.REACT_APP_API_URL || "/api";
  const { id } = useParams();

  const [formData, setFormData] = useState({
    titulo: "",
    autor: "",
    imgcard: "",
    linkpdfdoclink: "",
    linkjsondocindex: "",
    autorDocumento: "",
    nomeDocumento: "",
    dataComposicao: "",
    lugarComposicaoOuImpressao: "",
    imagemDocumento: "",
    nomeImagemDocumento: "",
    palavrachave: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    const loadDocumento = async () => {
      try {
        const response = await axios.get(`${apiUrl}/documentos/${id}`);
        setFormData({
          titulo: response.data.titulo || "",
          autor: response.data.autor || "",
          imgcard: response.data.imgcard || "",
          linkpdfdoclink: response.data.linkpdfdoclink || "",
          linkjsondocindex: response.data.linkjsondocindex || "",
          autorDocumento: response.data.autorDocumento || "",
          nomeDocumento: response.data.nomeDocumento || "",
          dataComposicao: response.data.dataComposicao || "",
          lugarComposicaoOuImpressao: response.data.lugarComposicaoOuImpressao || "",
          imagemDocumento: response.data.imagemDocumento || "",
          nomeImagemDocumento: response.data.nomeImagemDocumento || "",
          palavrachave: response.data.palavrachave || "",
        });
      } catch (error) {
        console.error(error);
        setAlertMessage({ type: "error", text: "Erro ao carregar documento." });
        setOpenSnackbar(true);
      }
    };

    loadDocumento();
  }, [apiUrl, id]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const setFieldValue = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleUploadError = (message) => {
    setAlertMessage({ type: "error", text: message });
    setOpenSnackbar(true);
  };
  const handleUploadSuccess = (message) => {
    setAlertMessage({ type: "success", text: message });
    setOpenSnackbar(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      setAlertMessage({
        type: "error",
        text: "Você precisa estar autenticado para editar o documento.",
      });
      setOpenSnackbar(true);
      return;
    }

    try {
      await axios.put(`${apiUrl}/documentos/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlertMessage({ type: "success", text: "Documento atualizado com sucesso!" });
      setOpenSnackbar(true);
    } catch (error) {
      console.error(error);
      setAlertMessage({ type: "error", text: "Erro ao atualizar documento." });
      setOpenSnackbar(true);
    }
  };

  return (
    <Container maxWidth="md">
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />

      <Typography
        variant="h2"
        align="center"
        gutterBottom
        style={{
          fontFamily: "'Lato', serif",
          color: "black",
          borderBottom: "4px solid #d4af37",
          paddingBottom: "10px",
          textTransform: "uppercase",
          marginTop: "7%",
        }}
      >
        Editar Documento Avulso
      </Typography>

      <form onSubmit={handleSubmit}>
        <Box mb={2}>
          <TextField fullWidth label="Titulo" name="titulo" value={formData.titulo} onChange={handleChange} required />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Autor" name="autor" value={formData.autor} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="Imagem do card"
            name="imgcard"
            value={formData.imgcard}
            onChange={setFieldValue}
            folder="imagenscards"
            accept="image/*"
            required
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="PDF do documento"
            name="linkpdfdoclink"
            value={formData.linkpdfdoclink}
            onChange={setFieldValue}
            folder="pdfDoc"
            accept=".pdf,application/pdf"
            required
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="JSON indexado"
            name="linkjsondocindex"
            value={formData.linkjsondocindex}
            onChange={setFieldValue}
            folder="pdfDoc"
            accept=".json,application/json,text/plain"
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Nome do documento" name="nomeDocumento" value={formData.nomeDocumento} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Autor do documento" name="autorDocumento" value={formData.autorDocumento} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Data de composicao" name="dataComposicao" value={formData.dataComposicao} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Lugar de composicao/impressao" name="lugarComposicaoOuImpressao" value={formData.lugarComposicaoOuImpressao} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="Imagem interna do documento"
            name="imagemDocumento"
            value={formData.imagemDocumento}
            onChange={setFieldValue}
            folder="imagensverbete"
            accept="image/*"
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Descricao da imagem do documento" name="nomeImagemDocumento" value={formData.nomeImagemDocumento} onChange={handleChange} />
        </Box>
        <Box mb={3}>
          <TextField fullWidth label="Palavras-chave" name="palavrachave" value={formData.palavrachave} onChange={handleChange} />
        </Box>
        <Button type="submit" fullWidth variant="contained" color="primary">
          Salvar Alteracoes
        </Button>
      </form>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
        <Alert severity={alertMessage.type}>{alertMessage.text}</Alert>
      </Snackbar>
    </Container>
  );
};

export default EditorDocumentos;
